"use client";

import { useContext } from "react";
import { RootStoreContext } from "../context";
import type AuthStore from "../../mobx/stores/auth/store.auth";

export function useAuth(): AuthStore {
  const root = useContext(RootStoreContext);
  if (!root) throw new Error("useAuth must be used within a RootStoreProvider");
  return root.auth;
}
